import { render, staticRenderFns } from "./goods.vue?vue&type=template&id=3060abab&scoped=true&"
var script = {}
import style0 from "./goods.vue?vue&type=style&index=0&id=3060abab&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3060abab",
  null
  
)

export default component.exports